/* eslint-disable camelcase */
import {
  SET_BOOKMARKS,
  BOOKMARKS_FETCHED_INITIAL,
  //BOOKMARK_ADDED,
  BOOKMARK_REMOVED,
  BOOKMARK_UPDATED,
  FOLLOW_REMOVED,
  BOOKMARKS_LOADING,
  // TOGGLE_CLUSTER_VISIBILITY,
} from './actions'
import { createReducer, createSelector } from '@reduxjs/toolkit'


export const setBookmarks = (data) => (dispatch) => {
    dispatch({
      type: SET_BOOKMARKS,
      data
    })
}

export const fetchBookmarks = ( page = 1 ) => (dispatch) => {
  dispatch({
    type: BOOKMARKS_LOADING,
    data: true
  })

  return fetch(`/profile/follows.json?page=${page}`)
    .then(res => res.json())
    .then(data => {
      dispatch({
        type:       SET_BOOKMARKS,
        parcels:    data.follows.parcels,
        places:     data.follows.places,
        page,
        totalPages: data.follows.parcels[0]?.total_pages,
        totalCount: data.follows.parcels[0]?.total_count,
      })
      dispatch({
        type: BOOKMARKS_FETCHED_INITIAL,
        data: true
      })
    })
    .catch((err) => {
      debug(`Bookmarks fetch failed: ${err}`)
    })
    .finally(() => {
      dispatch({
        type: BOOKMARKS_LOADING,
        data: false
      })
    })
}

export const removeBookmark = (path, sourceId, callback) => (dispatch) => {
  fetch(`${path}/bookmark.json`, {
    method:  'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      bookmark:  'remove',
      source_id: sourceId
    })
  })
  .then(res => res.json())
  .then(() => {
    dispatch({
      type:     BOOKMARK_REMOVED,
      sourceId: sourceId,
      path:     path
    })
    callback.success()
  })
  .catch(err => {
    debug(`Bookmark removal failed: ${err}`)
    callback.failed()
  })
}

export const removeFollow = (followId, callback) => (dispatch) => {
  fetch(`/notify/follows/${followId}.json`, {
    method:  'DELETE',
    headers: { 'Content-Type': 'application/json' }
  })
    .then(res => res.json())
    .then(() => {
      dispatch({
        type:     FOLLOW_REMOVED,
        followId: followId,
      })
      callback.success()
    })
    .catch(err => {
      debug(`Unfollow failed: ${err}`)
      callback.failed()
    })

}

/*export const removeAllBookmarks = (sourceId, callback) => (dispatch) => {
  fetch('/profile/bookmarks.json', {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ source_id: sourceId })
  })
  .then(res => res.json())
  .then(data => {
    dispatch({
      type: SET_BOOKMARKS,
      data: data.bookmarks
    });
    callback.success();
  })
  .catch(err => {
    debug(`Removal of all bookmarks failed: ${err}`);
    callback.failed();
  });
};*/


export const followBookmark = (path, sourceId, callback) => (dispatch) => {
  fetch(`/notify/follows.json`, {
    method:  'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      path:      path,
      source_id: sourceId,
    })
  })
    .then(res => res.json())
    .then(data => {
      dispatch({
        type:     BOOKMARK_UPDATED,
        bookmark: data.bookmark,
      })
      callback.success()
    })
    .catch(err => {
      debug(`Bookmark removal failed: ${err}`)
      callback.failed()
    })
}

export const unfollowBookmark = (blextId, callback) => (dispatch) => {
  fetch(`/notify/follows/${blextId}.json`, {
    method:  'DELETE',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(res => res.json())
    .then(data => {
      dispatch({
        type:     BOOKMARK_UPDATED,
        bookmark: data.bookmark,
      })
      callback.success()
    })
    .catch(err => {
      debug(`Bookmark removal failed: ${err}`)
      callback.failed()
    })
}

// Memoized selector for array of source objects
export const getBookmarkSources = createSelector(
  [(state) => state.bookmarks.bookmarkSources],
  (bookmarkSources) => bookmarkSources
)

export const getFollowedPlaces = (state) => {
  return state.bookmarks.followedPlaces
}

export const getBookmarksNeedInitialize = (state) => {
  return !state.bookmarks.fetchedInitial
}

export const hasBookmarksAvailable = (state) => {
  if(state.bookmarks.bookmarkSources.length > 0) {
    return state.bookmarks.bookmarkSources.some((b_source) => b_source.bookmarks.length > 0)
  }
  return null
}

export const hasFollowedPlaces = (state) => {
  return state.bookmarks.followedPlaces && state.bookmarks.followedPlaces.length > 0
}

export const getCurrentPage = (state) => {
  return state.bookmarks.page
}

export const getLoadedPages = (state) => {
  return state.bookmarks.loadedPages
}

export const getTotalPages = (state) => {
  return state.bookmarks.totalPages
}

export const getIsLoading = (state) => {
  return state.bookmarks.isLoading
}

export const getNumberOfBookmarks = (state) => {
  if(hasBookmarksAvailable(state)) {
    return state.bookmarks.bookmarkSources.reduce((acc, b_source) => acc + b_source.bookmarks.length, 0)
  }
  return null
}

// Value set by server response, may be incremented/decremented by add/remove actions
export const getBookmarkCount = (state) => {
  return state.bookmarks.totalCount
}

export const getClusterVisibility = (state) => {
  return state.bookmarks.clusterVisibility
}

const initialState = {
  bookmarkSources:    [],
  fetchedInitial:     false,
  page:               1,
  loadedPages:        [],
  totalPages:         null,
  totalCount:         null,
  isLoading:          false,
  clusterVisibility:  true,
}

const mergeBookmarkSources = (existing, incoming) => {
  const merged = [...existing]

  incoming.forEach((newGroup) => {
    const match = merged.find((group) => group.source_id === newGroup.source_id)

    if(match) {
      const existingIds = new Set(match.bookmarks.map((b) => b.id))
      const newUnique = newGroup.bookmarks.filter((b) => !existingIds.has(b.id))

      match.bookmarks = [...match.bookmarks, ...newUnique]
    } else {
      merged.push(newGroup)
    }
  })

  return merged
}


// Note: this uses redux toolkit's 'createReducer' (with immer) to simplify state manipulation
// https://redux.js.org/usage/structuring-reducers/immutable-update-patterns#simplifying-immutable-updates-with-redux-toolkit

export const bookmarks = createReducer(initialState, {
  SET_BOOKMARKS: (state, action) => {
    const isFirstPage = action.page === 1

    state.bookmarkSources = isFirstPage
      ? [...action.parcels] // ensure new array
      : mergeBookmarkSources(state.bookmarkSources, action.parcels)
    state.followedPlaces  = action.places
    state.page = action.page
    state.totalPages = action.totalPages
    state.totalCount = action.totalCount

    if(!state.loadedPages.includes(action.page)) {
      state.loadedPages.push(action.page)
    }
  },

  BOOKMARKS_FETCHED_INITIAL: (state, action) => {
    state.fetchedInitial = action.data
  },

  BOOKMARKS_LOADING: (state, action) => {
    state.isLoading = action.data
  },

  BOOKMARK_ADDED: (state, action) => {
    const { sourceId, bookmarkData, source } = action

    // Put it in the right source in the list
    // eslint-disable-next-line eqeqeq
    let sourceEntry = state.bookmarkSources.find(s => s.source_id == sourceId)

    // eslint-disable-next-line no-undef
    if(isNullOrUndefined(sourceEntry)) {
      // We don't have this source yet, create an entry
      sourceEntry = {
        source_id:  source.id,
        name:       source.name,
        bookmarks:  []
      }
      state.bookmarkSources = [...state.bookmarkSources, sourceEntry] // Ensure new array
    }

    sourceEntry.bookmarks = [bookmarkData, ...sourceEntry.bookmarks] // Ensure new array

    // Increment total count, more efficient than using length
    if(state.totalCount !== null) {
      state.totalCount += 1
    }
  },

  BOOKMARK_REMOVED: (state, action) => {
    const { sourceId, path } = action
    // eslint-disable-next-line eqeqeq
    const sourceEntry = state.bookmarkSources.find(s => s.source_id == sourceId)
    if(sourceEntry) {
      sourceEntry.bookmarks = sourceEntry.bookmarks.filter((item) => item.path !== path)

      // Decrement total count only if a bookmark was actually removed
      if(state.totalCount) {
        state.totalCount -= 1
      }
    }
  },

  FOLLOW_REMOVED: (state, action) => {
    const { followId } = action
    state.followedPlaces = _.reject(state.followedPlaces, { id: followId })
  },

  // For follow/unfollow updates, we receive the bookmark slim_json again
  BOOKMARK_UPDATED: (state, action) => {
    const { bookmark } = action
    // eslint-disable-next-line eqeqeq
    const sourceEntry = state.bookmarkSources.find(s => s.source_id == bookmark.source_id)
    debug('mark_updated sourceEntry:')
    debug(sourceEntry)
    if(sourceEntry) {
      const oldIndex = sourceEntry.bookmarks.findIndex((b) => b.id === bookmark.id)
      if(oldIndex > -1) {
        debug(`found old mark at ${oldIndex}`)
        // Replace the old bookmark with the new one and return a new array
        sourceEntry.bookmarks = [
          ...sourceEntry.bookmarks.slice(0, oldIndex),
          bookmark, // Drop-in replacement
          ...sourceEntry.bookmarks.slice(oldIndex + 1)
        ]
      } else {
        debug('did not find old mark')
      }
    }
  },
  // Toggle cluster visibility for Following sources
  TOGGLE_CLUSTER_VISIBILITY: (state, action) => {
    const { id } = action
    debug('Toggle cluster visibility for source:', id)
    // TODO should this toggle in the sourceEntry? Will this also update the sources state slice?
    // const sourceEntry = state.bookmarkSources.find(s => s.source_id === id)
    // if(sourceEntry) {
    //   sourceEntry.clusterVisibility = !sourceEntry.clusterVisibility
    // }
    state.clusterVisibility = !state.clusterVisibility
  }
})

export default bookmarks